import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import router from './config/router';

import 'virtual:uno.css';
import './styles/styles.scss';

import App from './App.vue';
import locale from './i18n/PrimeVue.json';
import i18n from './config/i18n';
import { enableAPIMocking } from './__tests__/msw/enableAPIMocking';

const app = createApp(App);

try {
  if (import.meta.env.PROD && import.meta.env.VITE_E2E_TESTING !== 'TRUE') {
    Sentry.init({
      app,
      dsn: 'https://0b4a57e12fed12a1d124fd4e97a5c5f3@o4506626731540480.ingest.sentry.io/4506626733899776',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      // Performance Monitoring
      // Capture 50% of the transactions
      tracesSampleRate: 0.5,
      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/innovatecave\.com\/api/],
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}
catch (e) {
  console.error('Sentry init failed', e);
}

enableAPIMocking().then(() => {
  const pinia = createPinia();
  app.use(pinia);

  app.use(router);

  app.use(PrimeVue, { locale, ripple: true });
  app.use(ToastService);
  app.use(VueQueryPlugin);
  app.use(ConfirmationService);
  app.use(i18n);
  app.directive('tooltip', Tooltip);
  app.mount('#app');
});
